export default __webpack_public_path__ + "static/media/tn_logo.ce3e9e19.svg";